import { TablePagination } from "@mui/material"
import React from "react"
import { TablePaginationFooterProps } from "./TablePaginationFooterProps"


export const TablePaginationFooter = ({ totalRows, rowsPerPage, page, handlePageChange, handleChangeRowsPerPage }: TablePaginationFooterProps) => {
    return <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component='div'
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
    />
}